export class LoginDto {
	login = '';
	password = '';
	switchRequest = false;
}
